import { useEffect, useState } from "react";
import { brandName, navItems } from "@/mocks/gossip";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled || menuOpen
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-20 items-center justify-between px-4 md:px-6 lg:px-10">
        {/* Brand */}
        <a href="#top" className="flex items-center gap-2.5 group">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 transition-transform group-hover:scale-105 ${
              scrolled ? "" : ""
            }`}
            aria-hidden="true"
          >
            <i className="ri-fire-fill text-lg text-background-50"></i>
          </span>
          <span
            className={`font-heading text-xl md:text-2xl font-bold tracking-wide transition-colors ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            {brandName}
          </span>
        </a>

        {/* Desktop nav */}
        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <a
              key={item.key}
              href={item.key}
              className={`rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:bg-background-100 hover:text-primary-600"
                  : "text-background-50/90 hover:bg-background-50/15 hover:text-background-50"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#hot"
            className={`hidden whitespace-nowrap rounded-full px-5 py-2.5 text-sm font-semibold transition-colors sm:inline-flex ${
              scrolled
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-background-50 text-primary-600 hover:bg-background-100"
            }`}
          >
            开始吃瓜
          </a>
          {/* Mobile toggle */}
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            aria-expanded={menuOpen}
            className={`flex h-10 w-10 items-center justify-center rounded-full border transition-colors md:hidden ${
              scrolled || menuOpen
                ? "border-background-200 text-foreground-900 hover:bg-background-100"
                : "border-background-50/30 text-background-50 hover:bg-background-50/15"
            }`}
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-4 md:hidden">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navItems.map((item) => (
              <a
                key={item.key}
                href={item.key}
                onClick={() => setMenuOpen(false)}
                className="rounded-lg px-3 py-3 text-base font-medium text-foreground-800 hover:bg-background-100 hover:text-primary-600"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#hot"
              onClick={() => setMenuOpen(false)}
              className="mt-2 inline-flex items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-5 py-3 text-base font-semibold text-background-50 hover:bg-primary-600"
            >
              开始吃瓜
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}